import { CheckCircle2 } from "lucide-react";
import PageHeader from "../components/PageHeader";
import Seo from "../components/Seo";

const METHODS = [
  "High-resolution front and back scanning of every card",
  "Controlled-light examination of centering, corners, edges & surface",
  "Forensic autograph comparison for signed items",
  "Tamper-evident, ultrasonically sealed archival holders",
  "Unique cert numbers with real-time online verification",
  "Transparent, live population registry for every card",
];

const CRITERIA = [
  { t: "Centering", d: "How evenly the image is framed within the borders, front and back." },
  { t: "Corners", d: "Sharpness and integrity of all four corners under magnification." },
  { t: "Edges", d: "Cleanliness and smoothness of the card's edges, free of chipping or wear." },
  { t: "Surface", d: "Print quality, gloss, and freedom from scratches, dents, or stains." },
];

export default function Standard() {
  return (
    <div className="bg-white" data-testid="standard-page">
      <Seo title="How Cards Are Graded — The MAS Grading Standard" description="How MAS grades trading cards: high-resolution scanning, controlled-light evaluation of centering, corners, edges, and surface, and tamper-evident encapsulation." path="/standard" />
      <PageHeader eyebrow="The MAS Standard" title="A grade you can stand behind" subtitle="Every MAS grade is the product of advanced, industry-leading methods and a consistent, transparent standard trusted by collectors, dealers, and auction houses worldwide." />
      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-28 grid lg:grid-cols-2 gap-16">
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-400">Our methods</span>
          <h2 className="font-display font-extrabold text-3xl md:text-4xl tracking-tight mt-4 text-[#0A0A0A]">Advanced, industry-leading process</h2>
          <ul className="mt-8 space-y-4">
            {METHODS.map((m) => (
              <li key={m} className="flex gap-3 text-neutral-600"><CheckCircle2 className="text-[#0A0A0A] shrink-0 mt-0.5" size={20} /><span>{m}</span></li>
            ))}
          </ul>
        </div>
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-400">What we evaluate</span>
          <h2 className="font-display font-extrabold text-3xl md:text-4xl tracking-tight mt-4 text-[#0A0A0A]">The four pillars of a grade</h2>
          <div className="grid sm:grid-cols-2 gap-4 mt-8">
            {CRITERIA.map((c) => (
              <div key={c.t} className="rounded-3xl border border-neutral-200 bg-[#FAFAFA] p-6">
                <h3 className="font-display font-bold text-lg text-[#0A0A0A]">{c.t}</h3>
                <p className="text-neutral-500 text-sm mt-2 leading-relaxed">{c.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
